import { render, staticRenderFns } from "./FormPatientTaxData.vue?vue&type=template&id=e5ae4ca2&scoped=true"
import script from "./FormPatientTaxData.vue?vue&type=script&lang=js"
export * from "./FormPatientTaxData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ae4ca2",
  null
  
)

export default component.exports